var image_upload_default = {
  "container": "_4taOH",
  "disabled": "z6Ku8",
  "imageInput": "c9bBK",
  "overlay": "z6eyg",
  "text": "_5vcgC",
  "shown": "eWC-A",
  "hide": "_876Vy",
  "spinner": "tE7ON",
  "spin": "qIBsE"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
